import { render } from "./AddBags.vue?vue&type=template&id=08743a9a&scoped=true&ts=true"
import script from "./AddBags.vue?vue&type=script&lang=ts"
export * from "./AddBags.vue?vue&type=script&lang=ts"

import "./AddBags.vue?vue&type=style&index=0&id=08743a9a&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08743a9a"]])

export default __exports__